import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-step-wizard',
  templateUrl: './step-wizard.component.html',
  styleUrls: ['./step-wizard.component.scss'],
})
export class StepWizardComponent {

  @Input() title: string;
  @Input() showTips: boolean;
  @Input() descr: string;
  @Input() postSubmitSectionContent: string | null = null;
  @Input() stepNumber: number;
  @Input() stepsTotal: number;
  @Input() showNextButton = true;
  @Input() lastStep = false;
  @Output() previousStepClicked = new EventEmitter();
  @Output() nextStepClicked = new EventEmitter();
  @Output() formCompleted = new EventEmitter();

  constructor() {
  }

  goToPreviousStep() {
    this.previousStepClicked.emit();
  }

  goToNextStep() {
    this.nextStepClicked.emit();
  }

  finishForm() {
    this.formCompleted.emit();
  }

}
